import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import { ReactComponent as UpIcon } from "../../assets/images/up_white_arrow.svg";
import { ReactComponent as DownIcon } from "../../assets/images/down_white_arrow.svg";

import styles from "./ModifierMenuItems.module.css";

const ModifierMenuItems = (props) => {
  const { menuList, selectedItems, selectedModifier, menuCategoryList } = props;

  const [selectedCatId, setSelectedCatId] = useState("");
  const [initialMenuItems, setInitialMenuItems] = useState([]);

  // Initialize top items when component mounts or selectedModifier changes
  useEffect(() => {
    // Get the initial selected items
    const initialTopItems = menuList.filter((item) =>
      selectedItems?.includes(item._id)
    );
    setInitialMenuItems(initialTopItems);
  }, [selectedModifier?._id]);

  // Update top items when selectedItems changes
  useEffect(() => {
    // Make a copy of the current topItems
    const updatedTopItems = [...initialMenuItems];

    // Add any new selected items that aren't already in topItems
    selectedItems.forEach((id) => {
      if (!updatedTopItems.some((item) => item._id === id)) {
        const menuItem = menuList.find((item) => item._id === id);
        if (menuItem) {
          updatedTopItems.push(menuItem);
        }
      }
    });

    if (updatedTopItems.length !== initialMenuItems.length) {
      setInitialMenuItems(updatedTopItems);
    }
  }, [selectedItems]);

  useEffect(() => {
    setSelectedCatId("");
  }, [selectedModifier?._id]);

  const handlerOnSelectCat = (cat) => {
    setSelectedCatId(selectedCatId === cat?._id ? "" : cat?._id);
  };

  const handlerOnSelectMenu = (menu) => {
    // Add this menu to topItems if it's not already there
    if (!initialMenuItems.some((item) => item._id === menu._id)) {
      setInitialMenuItems([...initialMenuItems, menu]);
    }
    // Call the parent component's handler
    props.onSelectMenu(menu);
  };

  const MenuListView = ({ menu }) => {
    // Important: use 'checked' not 'defaultChecked' to ensure the checkbox updates
    const checked = selectedItems?.includes(menu?._id);

    return (
      <FormControlLabel
        className={`${styles["checkbox-main-view"]}`}
        control={
          <Box className={`${styles["checkbox-view"]}`}>
            <Checkbox
              checked={checked}
              onChange={() => handlerOnSelectMenu(menu)}
              sx={{
                "& .MuiSvgIcon-root": { fontSize: 18 },
                color: "#FFF",
                "&.Mui-checked": {
                  color: "#FFF",
                },
              }}
            />
            <Typography className={`${styles["menu-text"]}`}>
              {menu.name}
            </Typography>
          </Box>
        }
        label={""}
      />
    );
  };

  return (
    <Box className={`${styles["main-view"]}`}>
      {/* Display all items in the top section, including deselected ones */}
      {initialMenuItems.length > 0 && (
        <Box>
          {initialMenuItems
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((menu, index) => {
              return <MenuListView key={`top-${menu._id}`} menu={menu} />;
            })}
          <Box sx={{ borderBottom: "1px solid #555", margin: "10px 0" }} />
        </Box>
      )}

      {/* Display all menu items in their categories */}
      {menuCategoryList.map((cat, index) => {
        const catList = cat?.menuList.sort((a, b) =>
          a.name.localeCompare(b.name)
        );

        if (catList.length === 0) {
          return null;
        }

        const expanded = selectedCatId === cat?._id;

        return (
          <Box key={index}>
            <Box
              className={`${styles["cat-name-view"]}`}
              onClick={() => handlerOnSelectCat(cat)}
            >
              <Typography className={`${styles["cat-name-text"]}`}>
                {cat?.name}
              </Typography>

              {expanded ? (
                <DownIcon width={25} height={25} />
              ) : (
                <UpIcon width={25} height={25} />
              )}
            </Box>
            <Box>
              {expanded
                ? catList.map((menu, index1) => {
                    return (
                      <MenuListView
                        key={`cat-${index}-item-${index1}`}
                        menu={menu}
                      />
                    );
                  })
                : null}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ModifierMenuItems;
